import { useState } from 'react';

function useToken() {

  function getToken() {
    const userToken = localStorage.getItem('tokenHydros99');
    return userToken && userToken
  }

  const [token, setToken] = useState(getToken());

  function saveToken(userToken) {
    localStorage.setItem('tokenHydros99', userToken);
    setToken(userToken);
  };

  function removeToken() {
    localStorage.removeItem('tokenHydros99');
    setToken(null);
  }

  return {
    setToken: saveToken,
    token,
    removeToken
  }

}

export default useToken;